import React, { useState } from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import slogo from 'assets/images/users/slogo.png';
import NavGroup from './NavGroup';
import menuItem from 'menu-items';

function filterMenuByUserType(groups, userType) {
  return groups.map(group => {
    if (group.type === "group" && Array.isArray(group.children)) {
      return {
        ...group,
        children: group.children.filter(item => {
          if (userType === "1") {
            if (item.id === "schedule-posts" || item.id === "messages" || item.id === "accounts") return false;
          }
          if (userType === "2") {
            if (item.id === "platform") return false;
          }
          if (userType === "3") {
            if (item.id === "users" || item.id === "plans" || item.id === "platform") return false;
          }
          if (userType === "4") {
            if (item.id === "users" || item.id === "platform") return false;
          }
          return true;
        })
      };
    }
    return group;
  });
}

export default function Navigation() {
  const userType = localStorage.getItem("userType");
  const filteredGroups = filterMenuByUserType(menuItem.items, userType);

  // State to track selected nav item
  const [selectedId, setSelectedId] = useState('dashboard');

  // Pass selectedId and setSelectedId to NavGroup
  const navGroups = filteredGroups.map((group) =>
    group.type === 'group'
      ? <NavGroup key={group.id} item={group} selectedId={selectedId} setSelectedId={setSelectedId} />
      : (
        <Typography key={group.id} variant="h6" color="error" align="center">
          Fix - Navigation Group
        </Typography>
      )
  );

  return (
    <Box sx={{
      overflow: 'hidden',
      width: '100%',
      minWidth: '200px',
      height: '100vh',
      boxSizing: 'border-box'
    }}>
      <Box
        sx={{
          overflow: 'hidden',
          width: "100%",
          height: '100%',
          color: '#fff',
          backgroundColor: '#0b1225',
          '& .MuiTypography-root, & .MuiListItem-root, & a': {
            color: '#fff',
          },
          '& svg, & .MuiSvgIcon-root': {
            color: '#fff',
            fill: '#fff'
          }
        }}
      >
        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          margin: 0,
          paddingLeft: "8%",
          paddingTop: "5%",
          paddingBottom: "20%"
        }}>
          <img
            src={slogo}
            alt="Social Media Hub"
            style={{ width: "16%", height: "16%", borderRadius: '12%' }}
          />
          <Typography
            variant="h6"
            sx={{
              fontWeight: 'bold',
              color: '#fff',
              letterSpacing: 0.5,
              padding: '3%',
              fontSize: '100%',
            }}
          >
            Social Media Hub
          </Typography>
        </Box>
        {navGroups}
      </Box>
    </Box>
  );
}
